import { render, staticRenderFns } from "./salesExample.vue?vue&type=template&id=8163c780&scoped=true"
import script from "./salesExample.vue?vue&type=script&lang=js"
export * from "./salesExample.vue?vue&type=script&lang=js"
import style0 from "./salesExample.vue?vue&type=style&index=0&id=8163c780&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8163c780",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8163c780')) {
      api.createRecord('8163c780', component.options)
    } else {
      api.reload('8163c780', component.options)
    }
    module.hot.accept("./salesExample.vue?vue&type=template&id=8163c780&scoped=true", function () {
      api.rerender('8163c780', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/optimization/salesExample.vue"
export default component.exports